<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">
            <div class="brand"></div>
          </div>
        </div>
      </div>
    </parallax>

    <div class="main main-raised">
      <div class>
        <div class="container-carosel">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 mx-auto md-small-size-100">
              <md-card>
                <carousel
                  :per-page="1"
                  loop
                  :speed="700"
                  autoplay
                  :autoplay-timeout="5000"
                  :mouse-drag="false"
                  navigationEnabled
                  navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
                  navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>"
                >
                  <slide>
                    <img :src="carousel1" alt="carousel1" />
                  </slide>
                  <slide>
                    <img :src="carousel2" alt="carousel2" />
                  </slide>
                  <slide>
                    <img :src="carousel3" alt="carousel3" />
                  </slide>
                </carousel>
              </md-card>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div id="images">
            <div class="title">
              <h2>{{ $t("热卖产品") }}</h2>
              <md-divider></md-divider>
            </div>
            <div class="md-layout">
              <div
                class="md-layout-item md-size-20 md-xsmall-size-100"
                v-for="(product, product_index) in products"
                :key="product_index"
              >
                <router-link :to="{ name: 'product', params: {id: product.id}}">
                  <img :src="product.image_url" class="img-raised rounded" />
                </router-link>
                <h4>{{product.name_cn}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "index",
  bodyClass: "index-page",
  props: {
    img_parallax: {
      type: String,
      default: require("@/assets/img/ln/parallax.jpg")
    }
  },
  data() {
    return {
      carousel1: require("@/assets/img/ln/banner_1.jpg"),
      carousel2: require("@/assets/img/ln/banner_2.jpg"),
      carousel3: require("@/assets/img/ln/banner_3.jpg"),
      products: []
    };
  },
  methods: {
    async getProducts() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_product_get.php",
        data: {
          search_criteria: {
            hot_sales: 1
          }
        }
      });
      this.products = response.data.products;
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.img_parallax})`
      };
    }
  },
  async created() {
    await this.getProducts();
  },
  mounted() {},
  beforeDestroy() {}
};
</script>
<style lang="scss">
.container-carosel {
  padding-left: 15px;
  padding-right: 15px;
}
</style>
